export default __webpack_public_path__ + "static/media/Career_Ashley.85b5aac2.jpg";